<template>
  <div id="gestantes-puerperas" class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Gestantes">
          <template #title> <i class="icofont-list"></i> Gestantes </template>
          <div class="info-table py-4">
            <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                :setRed="setRed"
              />
            </div>
            <div class="info-table-item">
              <vue-select
                v-model="selectedFilterBoasPraticas"
                :options="optionsFilterBoasPraticasGestantes"
                label="label"
                placeholder="Boas práticas"
                :clearable="true"
                @input="onChangeFilterBoasPraticas"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="info-table-item">
              <DownloadFiles
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="gestantes-puerperas"
              />
            </div>
          </div>
          <TabelaCadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            :selectedFilterBoasPraticas="selectedFilterBoasPraticas"
            @filterSearch="filterSearch"
            tipo="gestantes"
          />
        </b-tab>

        <b-tab title="Puérperas">
          <template #title>
            <span style="text-transform: none"
              ><i class="icofont-list"></i> Puérperas</span
            >
          </template>
          <div class="info-table py-4">
            <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                :setRed="setRedPuerperas"
              />
            </div>
            <div class="info-table-item">
              <vue-select
                v-model="selectedFilterBoasPraticasPuerperas"
                :options="optionsFilterBoasPraticasPuerperas"
                label="label"
                placeholder="Boas práticas"
                :clearable="true"
                @input="onChangeFilterBoasPraticas"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="info-table-item">
              <DownloadFiles
                :callback-pdf="generatePdf"
                :data="displayedCadastrosPuerperas"
                :fields="dataFields"
                name="gestantes-puerperas"
              />
            </div>
          </div>
          <TabelaCadastros
            ref="tablePuerperas"
            :cadastros="displayedCadastrosPuerperas"
            :loading="loading"
            :selectedFilterBoasPraticas="selectedFilterBoasPraticas"
            @filterSearch="filterSearch"
            tipo="puerperas"
          />
        </b-tab>

        <b-tab title="Percentual">
          <template #title>
            <i class="icofont-mathematical-alt-1"></i> Percentual
          </template>
          <div class="row mt-4">
            <div class="col-md-4">
              <vue-select
                v-model="selectedFilterBoasPraticasTabelaPercentual"
                :options="optionsFilterBoasPraticasPuerperas"
                label="label"
                placeholder="Boas práticas"
                :clearable="true"
                @input="onChangeFilterBoasPraticasPercentual"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <TabelaPercentual
            :loading="loading"
            :municipio="dadosPercentualMunicipio"
            :equipe="dadosPercentualEquipe"
            :micro_area="dadosPercentualMicroArea"
            :selectedEquipe="equipe"
            :selectedMicroArea="microArea"
            :selectedFilterBoasPraticas="
              selectedFilterBoasPraticasTabelaPercentual
            "
          />
          <GraficoPercentual
            :equipe="equipe"
            :micro_area="microArea"
            ref="graficoPercentual"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Subtitle from './components/Subtitle.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import {
  dataFields,
  optionsFilterBoasPraticasGestantes,
  optionsFilterBoasPraticasPuerperas,
} from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './components/TabelaCadastros.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import TabelaPercentual from './components/TabelaPercentual.vue'
import GraficoPercentual from './components/GraficoPercentual.vue'

export default {
  name: 'GestantePuerperas',
  components: {
    Subtitle,
    PulseLoader,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    TabelaCadastros,
    SelectsV2,
    TabelaPercentual,
    GraficoPercentual,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      equipe: '',
      microArea: '',
      microAreas: [],
      cadastros: [],
      cadastrosPuerperas: [],
      cadastrosOriginais: [],
      dadosPercentualMunicipio: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualEquipe: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualMicroArea: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosTabelaPercentual: [],
      dadosGraficoPercentual: [],
      loading: false,
      tabsActive: 0,
      setRed: false,
      setRedPuerperas: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      exibirCadastrosVermelhosPuerperas: false,
      exibirCadastrosVerdesPuerperas: false,
      filterSearchTable: false,
      filterSearchTablePuerperas: false,
      dataFields: { ...dataFields },
      filterItemsPuerperas: [
        {
          label: 'Denominador',
          value: 'denominador',
        },
        {
          label: 'Com parto',
          value: 'com-parto',
        },
        {
          label: 'Todas',
          value: 'todas',
        },
      ],
      filterItemPuerpera: {
        label: 'Denominador',
        value: 'denominador',
      },
      selectedFilterBoasPraticas: null,
      selectedFilterBoasPraticasPuerperas: null,
      selectedFilterBoasPraticasTabelaPercentual: null,
      optionsFilterBoasPraticasGestantes: [
        ...optionsFilterBoasPraticasGestantes,
      ],
      optionsFilterBoasPraticasPuerperas: [
        ...optionsFilterBoasPraticasPuerperas,
      ],
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable) return this.filterSearchTable
      const resultado = Filter.filtro(
        this.cadastros,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes,
        this.selectedFilterBoasPraticas
      )
      return resultado || []
    },
    displayedCadastrosPuerperas() {
      if (this.filterSearchTablePuerperas)
        return this.filterSearchTablePuerperas

      const resultado = Filter.filtroPuerperas(
        this.cadastrosPuerperas,
        this.exibirCadastrosVermelhosPuerperas,
        this.exibirCadastrosVerdesPuerperas,
        this.selectedFilterBoasPraticasPuerperas
      )

      return resultado || []
    },
  },
  methods: {
    filtros(vermelho, verde) {
      if (this.tabsActive == 0) {
        if (this.$refs.table) this.$refs.table.search = ''
        this.setRed = vermelho
        this.exibirCadastrosVermelhos = vermelho
        this.exibirCadastrosVerdes = verde && !vermelho
      }
      if (this.tabsActive == 1) {
        if (this.$refs.tablePuerperas) this.$refs.tablePuerperas.search = ''
        this.setRedPuerperas = vermelho
        this.exibirCadastrosVermelhosPuerperas = vermelho
        this.exibirCadastrosVerdesPuerperas = verde && !vermelho
      }
    },

    filterSearch(item) {
      if (this.tabsActive == 0) {
        this.filterSearchTable = item.filter || false
      }
      if (this.tabsActive == 1) {
        this.filterSearchTablePuerperas = item.filter || false
      }
    },

    handleExibirVermelhos(valor) {
      this.filtros(valor, false)
    },

    handleExibirVerdes(valor) {
      this.filtros(false, valor)
    },

    async onChangeEquipe(event) {
      if (this.tabsActive == 0) {
        if (this.$refs.table) this.$refs.table.search = ''
      }
      if (this.tabsActive == 1) {
        if (this.$refs.tablePuerperas) this.$refs.tablePuerperas.search = ''
      }

      this.equipe = event
      this.microArea = ''
      this.resetDadosMicroArea()

      this.setRed = true
      // this.setRedPuerperas = true

      if (event) {
        this.resetCadastros()
        await this.buscarCadastrosPorEquipe()
      } else {
        this.resetDadosEquipe()
        this.resetCadastros()
      }

      this.setarPercentualEquipe()
    },

    async onChangeMicroArea(event) {
      if (this.tabsActive == 0) {
        if (this.$refs.table) this.$refs.table.search = ''
      }
      if (this.tabsActive == 1) {
        if (this.$refs.tablePuerperas) this.$refs.tablePuerperas.search = ''
      }
      this.microArea = event?.micro_area || ''
      this.resetDadosMicroArea()

      this.setRed = true
      // this.setRedPuerperas = true

      if (event && this.microArea) {
        this.loading = true
        await this.buscarCadastrosMicroArea()
        this.loading = false
      } else {
        await this.onChangeEquipe(this.equipe)
      }

      this.setarPercentualMicroArea()
    },

    async buscarCadastrosPorEquipe() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap
      )
      if (resposta) {
        this.cadastrosOriginais = resposta
        this.cadastros = resposta.filter((item) => {
          return Number(item.den_gestante) == 1
        })
        this.cadastrosPuerperas = resposta.filter((item) => {
          return (
            Number(item.den_puerpera) == 1 || Number(item.den_gestante) == 2
          )
        })
        this.filtros(true, false)
      }
      this.loading = false
    },

    async buscarCadastrosMicroArea() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorMicroArea(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap,
        this.microArea
      )
      if (resposta) {
        this.cadastrosOriginais = resposta
        this.cadastros = resposta.filter((item) => {
          return Number(item.den_gestante) == 1
        })
        this.cadastrosPuerperas = resposta.filter((item) => {
          return (
            Number(item.den_puerpera) == 1 || Number(item.den_gestante) == 2
          )
        })
        this.filtros(true, false)
      }
      this.loading = false
    },

    onChangeFilterBoasPraticas(item) {
      this.handleExibirVermelhos(true)
    },

    onChangeFilterBoasPraticasPercentual(item) {
      this.setarPercentualMunicipio()
      if (this.equipe != '') {
        this.setarPercentualEquipe()
      }
      if (this.microArea != '') {
        this.setarPercentualMicroArea()
      }
    },

    setarPercentualMunicipio() {
      const resultado = Functions.percentualMunicipio(
        this.dadosGraficoPercentual,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualMunicipio, resultado)
      this.$refs.graficoPercentual.serieHistoricaMunicipio(
        this.dadosGraficoPercentual
      )
    },

    setarPercentualEquipe() {
      const resultado = Functions.percentualEquipe(
        this.dadosGraficoPercentual,
        this.equipe.ine_esf_eap,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualEquipe, resultado)
      this.$refs.graficoPercentual.serieHistoricaEquipe(
        this.dadosGraficoPercentual,
        this.equipe
      )
    },

    async setarPercentualMicroArea() {
      if (!this.microArea) return
      const resultado = Functions.percentualMicroArea(
        this.dadosGraficoPercentual,
        this.equipe.ine_esf_eap,
        this.microArea,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualMicroArea, resultado)
      this.$refs.graficoPercentual.serieHistoricaMicroArea(
        this.dadosGraficoPercentual,
        this.equipe,
        this.microArea
      )
    },

    resetCadastros() {
      this.cadastros = []
      this.cadastrosOriginais = []
    },

    resetDadosEquipe() {
      this.equipe = ''
      this.dadosPercentualEquipe = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    resetDadosMicroArea() {
      this.dadosPercentualMicroArea = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    generatePdf() {
      let dados = []
      let filter = null
      if (this.tabsActive == 0) {
        dados = this.displayedCadastros
        filter = this.selectedFilterBoasPraticas
      }
      if (this.tabsActive == 1) {
        dados = this.displayedCadastrosPuerperas
        filter = this.selectedFilterBoasPraticasPuerperas
      }
      Functions.generatePdf(dados, this.equipe, this.microArea, filter)
    },

    async init() {
      try {
        const response2 = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[52]`
        )
        this.dadosGraficoPercentual = response2.data
        this.setarPercentualMunicipio()
        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            this.buscarCadastrosPorEquipe()
            this.setarPercentualEquipe()
          }
        }

        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            this.setarPercentualEquipe()
          }
          this.microArea = this.$store.state.micro_area
          this.buscarCadastrosMicroArea()
          this.setarPercentualMicroArea()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style scoped>
#gestantes-puerperas .v-select {
  min-width: 300px !important;
}
</style>
